<template>
    <div class="temp-term">
        <span v-if="localeCode == 1054">
            ฉันยอมรับ<u @click="showModalTerm()">เงื่อนไขข้อกำหนดของดิออร์</u> และ<u @click="showModalPrivacy()">นโยบายส่วนบุคคล</u>
        </span>
        <span v-else>
            I agree to the Dior's <u @click="showModalTerm()">terms and conditions</u> and <u @click="showModalPrivacy()">privacy policy.</u>
        </span>
        <!-- {{lbl.register.agree.name}}
        <u>
        <a @click="showModalTerm">{{lbl.register.term.name}}</a>
        </u>
        and
        <u>
        <a @click="showModalPrivacy">privacy policy</a>
        </u>. -->
        <!-- term modal -->
        <b-modal :id="modalTerm.id"
                 @hidden="onModalTermHidden()"
                 modal-class="modal-term"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc
                 >
            <div class="modal-base">
                <div class="modal-base-head">
                    <div></div>
                    <button @click="hideModalTerm" class="close-button">x</button>
                </div>
                <div class= "modal-base-body-wrapper">
                <div class="modal-base-body">
                    <p class="text-center font-weight-bold term-title">{{modalTerm.title}}</p>
                    <iframe class="iframe"  :src="modalTerm.link"></iframe>
                </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
import Locale from "@/helper/locale/locale.js";

/**
 * @property {string} view require - view unique name
 * @property {Vue} busModal optional - object for control modal
 *
 * Event callback
 * - term
 * @event modalTermOk
 * @event modalTermCancel
 * @event modalTermHidden
 * Call function by busModal event
 * - term
 * @function showTermModal
 * @function hideTermModal
 * - privacy
 * @function showPrivacyModal
 */
export default {
    name: "TermConditionModal",
    props: {
        view: String,
        busModal: Object,
    },
    data: function() {
        return {
            modalTerm: {
                id: 'modal-term',
                title: '',
                strBtnOk: '',
                strBtnCancel: '',
                message: '',
                tag: '',
                isChecked: false,
            },
            lbl: Locale.getLbl(),
            localeCode: Locale.getLocaleCode(),

            termsVersion: 1,
            privacyVersion: 1,

            bzbConfig: Vue.bzbsConfig,
        };
    },
    mounted: function() {
        if (this.busModal) {
            this.busModal.$on('showTermModal', this.showModalTerm);
            this.busModal.$on('hideTermModal', this.hideModalTerm);
        }
        this.getVersion();
    },
    methods: {
        showModalTerm: function() {
            ///vuemisc/#/pdpa/privacy/appid/187688842321785/version/1/locale/1054
            if(this.localeCode == 1033){
                this.modalTerm.title = "TERMS AND CONDITIONS";
            }
            else if (this.localeCode== 1054){
                this.modalTerm.title = "เงื่อนไขและข้อกำหนด";
            }
            this.modalTerm.link = this.bzbConfig.miscUrl + "/vuemisc/#/pdpa/terms/appid/" + this.bzbConfig.client_id + "/version/1/locale/" + this.localeCode ;
            this.$bvModal.show(this.modalTerm.id);
        },
        showModalPrivacy: function() {
            if(this.localeCode == 1033){
                this.modalTerm.title = "PRIVACY POLICY";
            }
            else if (this.localeCode== 1054){
                this.modalTerm.title = "นโยบายความเป็นส่วนตัว";
            }
            this.modalTerm.link = this.bzbConfig.miscUrl + "/vuemisc/#/pdpa/privacy/appid/" + this.bzbConfig.client_id + "/version/" + this.termsVersion + "/locale/" + this.localeCode ;
            this.$bvModal.show(this.modalTerm.id);
        },
        getVersion: function () {
            var url = this.bzbConfig.bzbsBlobUrl + '/pdpaconsent/'+ this.bzbConfig.client_id +'/version';
            fetch(url).then((response) => {
                return response.json().then((json) => {
                    this.json = json;
                    if (this.json.terms && this.json.terms.latest_version) {
                        this.termsVersion = this.json.terms.latest_version;
                    }
                    if (this.json.privacy && this.json.privacy.latest_version) {
                        this.privacyVersion = this.json.privacy.latest_version;
                    }
                })
            })
            this.iframe += this.version + "/locale/" + this.locale;
        },
        hideModalTerm: function() {
            this.$bvModal.hide(this.modalTerm.id);
        },
        clickOkModalTerm: function() {
            this.hideModalTerm();
            this.$emit('modalTermOk', { tag: this.modalTerm.tag });
        },
        clickCancelModalTerm: function() {
            this.hideModalTerm();
            this.$emit('modalTermCancel', { tag: this.modalTerm.tag });
        },
        onModalTermHidden: function() {
            this.$emit('modalTermHidden', { tag: this.modalTerm.tag });
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/component/modal/TermConditionModal.scss";
</style>
<style lang="scss" >
#modal-term{
        height: 100%;
       .modal-dialog{
                padding: 0 25px;
            .modal-content{
                height: 550px;
                border-radius: 0px;
                border: none;

                .modal-body{
                    padding: 0px;
                    .modal-base{
                        .modal-base-body-wrapper{
                            padding: 0 16px;
                            .modal-base-body{
                                overflow-x: hidden;
                                overflow-y: scroll;
                                overflow: -moz-scrollbars-vertical;
                                height: 480px;
                                -webkit-overflow-scrolling: touch;
                                .iframe{
                                    max-width: calc( 100vw - 0.5rem - 10px);
                                    width: 100%;
                                    border: none;
                                    height: 85%;
                                    font-weight: bold;
                                    #document{
                                        html{
                                            body{
                                                font-size: 0.1rem;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
